import { IconV1 } from 'common/icon/iconV1.js';
import { ComponentLink } from 'common/link/link-component.js';
import { LinkTarget } from 'types/navigation.js';
import { IWarningLocationItem } from './location.item.js';

export const WarningLocationItemLink = ({
  filteredWarnings,
  children,
}: IWarningLocationItem & { children: JSX.Element }) => {
  const hasLink = filteredWarnings.filter((f) => f.url)?.[0];
  if (hasLink) {
    return (
      <ComponentLink
        url={hasLink.url}
        target={LinkTarget.SELF}
        data-module="LocationList-item-warning"
        urlClasses="LocationList-item-link"
      >
        <>
          {children}
          <span className="LocationList-item-link-actions">
            <IconV1 icon="chevron-right" iconClass="svg--1em" />
          </span>
        </>
      </ComponentLink>
    );
  }
  return <div className="LocationList-item-link">{children}</div>;
};
